import React from 'react';

const days = new Array(6).fill(1);
export default () => (
  <div className='schedule-month-grid-container'>
    {days.map(() => (
      <div className='schedule-month-grid-line'/>
    ))}
  </div>
)